<template>
  <div class="indexa">
    <!-- 合作伙伴 -->
    <div class="indexa_box">
      <!-- <img src="../../static/bg.png" alt=""> -->
    </div>
    <div style="width:800px;margin:0 auto;margin-bottom:100px;">
      <el-carousel :interval="4000" type="card" height="300px" width="400px">
        <el-carousel-item v-for="item in imgArr" :key="item">
          <!-- <h3 class="medium">{{ item }}</h3> -->
          <img :src="item" alt="" style="width:100%;height:100%;">
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
export default {
  name: "indexa",
  data() {
    return {
      imgArr:[
        "https://ss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=36293247,1325499932&fm=26&gp=0.jpg",
        "https://ss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=3503278423,3344032055&fm=26&gp=0.jpg",
        "https://ss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=1874103416,544371974&fm=26&gp=0.jpg",
        "https://ss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=1170976477,1523729251&fm=26&gp=0.jpg",
        "https://ss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=1289696530,2755348212&fm=26&gp=0.jpg",
      ]
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.indexa {
  /* background: #000; */
  text-align: center;
}
.indexa_box {
  /* width: 1200px; */
  margin: 0 auto;
}
img {
  width: 100%;
}
/*当屏幕尺寸大于1340px时小于1510，应用下面的CSS样式*/
@media screen and (min-width: 1340px) and (max-width: 1510px) {
  .indexa_box {
    /* transform: scale(1.3);
    margin-top: 465px; */
  }
}
@media screen and (min-width: 1200px) and (max-width: 1339px) {
  /*当屏幕尺寸小于1340px，大于1200时，应用下面的CSS样式*/
  .indexa_box {
    /* transform: scale(1.5);
    margin-top: 700px; */
  }
}

@media screen and (min-width: 1640px) {
  /* 当大于1640 */
  .indexa_box {
    width: 100%;
    height: 100%;
  }
}
@media screen and (max-width: 1200px) {
  /* 当小于1200 */
  .indexa_box {
    width: 1200px;
    /* transform: scale(1.5);
    margin-top: 700px; */
    /* margin-top: 450px; */
    /* 
     margin-top: 0px; */
    /* width: 1500px; */
  }
}

/* 当屏幕宽度大于1510小于1629 */
@media screen and (min-width: 1510px) and (max-width: 1629px) {
}
/* 当屏幕宽度大于1630 */
@media screen and (min-width: 1630px) {
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
</style>



// WEBPACK FOOTER //
// src/components/indexa.vue